import {useState } from "react";
import { toast} from 'react-hot-toast';
import { find, includes} from "lodash";
import {
  HiDotsVertical,
  HiOutlinePencil,
  HiOutlineTrash,
} from "react-icons/hi";
import {
  useUsersAdminAction,
} from "../../../services/actions/users-admin.actions";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  crudUsersAdminAtom,
  usersAdminAtom,
} from "../../../services/atoms/users-admin.atom";
import LocalTable from "../../../components/table-local";
import EditUserAdminModal from "./components/edit-modal";

const options = [
    { id: 'opt-1', title: 'Editar Usuario', action: 'edit', icon: HiOutlinePencil },
    { id: 'opt-2', title: 'Eliminar Usuario', action: 'remove', icon: HiOutlineTrash },
  ];

const getAttributes = (Attributes, key, additionalkey = '') => {
    let row = find(Attributes, (e) => e.Name === key);
    if (additionalkey) {
      let additionalRow = find(Attributes, (e) => e.Name === additionalkey);
      return <div>{`${row?.Value || ''} ${additionalRow?.Value || ''}`}</div>;
    }
    if(key==='custom:admin'){
     let rowRol = find(Attributes, (e) => e.Name === key);
     return <div>{rowRol?.Value === 'true' ? 'Administrador Empresa' : 'Analista'}</div>
    }
    return <div>{row?.Value || ''}</div>
  }

const columns = [
  {
    Header: "Nombre Completo",
    accessor: ({ Attributes }) =>
      getAttributes(Attributes, "name", "family_name"),
    disableSortBy: true,
  },
  {
    Header: "Correo",
    accessor: ({ Attributes }) => getAttributes(Attributes, "email"),
    disableSortBy: true,
  },
  {
    Header: "Rol",
    accessor: ({ Attributes }) => getAttributes(Attributes, "custom:admin"),
    disableSortBy: true,
  },
  { Header: 'Acciones', accessor: '', type: 'actions', disableSortBy: true },
];

const UsersAdmin = (props) => {
  const {clientName} = props;
  const { usersAdminsList, deleteUsersAdmin} = useUsersAdminAction();
  const [usersAdmin, setUsersAdmin] = useRecoilState(usersAdminAtom);
  const usersAdminResolver = useRecoilValue(crudUsersAdminAtom);
  const [open, setOpen] = useState({ edit: false, create: false });
  const [selectedUser, setUserSelected] = useState(null);

  const handleOpenModal = (key) =>
    setOpen((modal) => ({ ...modal, [key]: !modal[key] }));

  const handleOptionAction = (action, row) => {
    if (action === "remove") {
      handleDeleteAdminUsers(row);
    }
    if (action === "edit") {
      setUserSelected(row);
      handleOpenModal("edit");
    }
  };

  const handleDeleteAdminUsers = (row) => {
    toast((t) => (
      <div className="gm-modal-form-group">
        <p style={{color:'#003849'}}>¿Estás seguro de que quieres eliminar este usuario?</p>
        <div style={{display:'flex', justifyContent:'space-around'}}>
        <button
          className="gm-secondary-button"
          onClick={() => handleCancel(t.id)}
        >
          Cancelar
        </button>
        <button className="gm-primary-button" onClick={() => handleConfirm(t.id, row)}>
          Confirmar
        </button>
        </div>
  
  
      </div>
    ), {duration: 10000});
  }

  const handleCancel = (toastId) => {
    toast.dismiss(toastId);
  };

  const handleConfirm = (toastId, row) => {
    let username = find(row?.Attributes || [], (e) => e?.Name === 'email');
    deleteUsersAdmin(username?.Value || '', (res) => {
      if (includes(res?.message, 'Request failed with status')) {
        toast.error('El usuario no se ha podido eliminar', {duration:4000});
      } else {
        toast.success('Usuario eliminado exitosamente', {duration:4000});
        usersAdminsList(clientName);
        toast.dismiss(toastId);
      }
    });
  };

  const actions = [{ icon: HiDotsVertical, dropdown: true }];

  return (
    <div>
      {open.edit && (
        <EditUserAdminModal
        open={open.edit}
        toggle={()=>handleOpenModal('edit')}
        selectedUser={selectedUser}
        clientName={clientName}
        />
      )}
      <LocalTable
        className="qs-table-header-light"
        columns={columns}
        actions={actions}
        options={options}
        handleOptionAction={handleOptionAction}
        data={usersAdmin?.payload || []}
        loading={usersAdmin.loading || usersAdminResolver.loading}
      />
    </div>
  );
};

export default UsersAdmin;
